export const TIME_PATTERNS = {
  HOURS: 'hh',
  MINUTES: 'mm',
  SECONDS: 'ss',
  PERIOD: 'a',
};

const TIMEFORMAT_VALIDATOR = /^hh:mm:ss(\sa)?$|^hh:mm(\sa)?$|^mm:ss$|^hh(\sa)?$|^mm$|^ss$/;

/**
 * Custom prop validator for time format pattern
 * */
export const timeFormatPattern = (props, propName, componentName) => {
  const regex = new RegExp(TIMEFORMAT_VALIDATOR, 'gm');
  const propValue = props[propName];

  if (propValue == null || regex.test(propValue)) {
    return null;
  }

  return new Error(
    `Invalid prop ${propName} supplied to ${componentName}.`
      + ` Format should respect pattern form ${TIME_PATTERNS.HOURS}:${TIME_PATTERNS.MINUTES}:${TIME_PATTERNS.SECONDS}`
  );
};
